
import lazyload from "@/directives/lazyload";
import judi from "@/assets/images/landing/img/Judi.png";
import Don from "@/assets/images/landing/img/Don.png";
import Aaliya from "@/assets/images/landing/img/Aaliya.png";
import Susan from "@/assets/images/landing/img/Susan.png";
import mxfx from "@/assets/images/landing/img/mxfx.png";

import Margarite from "@/assets/images/landing/img/Margarite.png";
import TheoX from "@/assets/images/landing/img/TheoX.png";
import Maddie from "@/assets/images/landing/img/Maddie.png";
import jessica from "@/assets/images/landing/img/Jessica-ava.png";
import rique from "@/assets/images/landing/img/rique-ava.png";
import sara from "@/assets/images/landing/img/sara-ava.png";
import patricia from "@/assets/images/landing/img/patricia-ava.png";
import gwen from "@/assets/images/landing/img/gwen-ava.png";
import amy from "@/assets/images/landing/img/amy-ava.png";
import mira from "@/assets/images/landing/img/mira-ava.png";
import athena from "@/assets/images/landing/img/athena-ava.png";
import lila from "@/assets/images/landing/img/lila.jpg";

import american from "@/assets/images/landing/svg/flag-american.svg";
import canada from "@/assets/images/landing/svg/flag-canada.svg";
import united from "@/assets/images/landing/svg/flag-united.svg";
import mexico from "@/assets/images/landing/svg/flag-mexico.svg";
import germany from "@/assets/images/landing/svg/flag-germany.svg";
import brazil from "@/assets/images/landing/svg/flag-brazil.svg";
import amanda from "@/assets/images/landing/img/amanda-ava.png";
import australia from "@/assets/images/landing/svg/flag-australia.svg";
import arab from "@/assets/images/landing/svg/flag-arab.svg";
import africa from "@/assets/images/landing/svg/flag-africa.svg";
export default {
  data() {
    return {
      images: {
        mxfx,
        Susan,
        lila,
        Aaliya,
        Don,
        Margarite,
        judi,
        TheoX,
        Maddie,
        jessica,
        rique,
        sara,
        patricia,
        gwen,
        amy,
        amanda,
        mira,
        athena,
      },
      flags: {
        american,
        canada,
        united,
        mexico,
        germany,
        brazil,
        australia,
        arab,
        africa,
      },
    };
  },
  directives: {
    lazyload,
  },
};
